module.exports = __webpack_public_path__ + "img/hemline_sweep.f5b45282.png";